import { Component, EventEmitter, forwardRef, Inject, Injector, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { BaseInputComponent } from '../base-input-component';
import { ControlService } from '../control.service';

@Component({
  selector: 'qm-chips[titleMessage]',
  template: `
  <qm-input-title [titleMessage]="titleMessage" [optionalField]="!this.required"></qm-input-title>
  <p-chips
  [max]="maxElements"
  [ngModel]="controlValue"
  (ngModelChange)="onModelChange($event)"
  (onBlur)="onTouched()"
  (onAdd)="onChangeValue($event)"
  (onRemove)="onChangeValue($event)"
  [disabled]="disabled"
  [addOnTab]="createOnTab"
  [ngClass]="{'ng-dirty ng-invalid': invalidInput}"
  inputStyleClass="w-full"
  styleClass="mt-2 mb-1"></p-chips>
  <qm-input-legend [legendMessage]="legendMessage" [errorInput]="invalidInput"></qm-input-legend>
  `,
  styleUrls: ['./qm-chips.component.css'],
  providers: [
    {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => QmChipsComponent),
        multi: true
    }
]
})
export class QmChipsComponent extends BaseInputComponent implements OnInit, ControlValueAccessor {

  controlValue!: string[] | undefined;
  onChanged = (_val: any) => {};
  onTouched = () => {}

  @Input()
  maxElements!: number;

  @Input()
  createOnTab: boolean = false;

  @Output()
  changeEvent = new EventEmitter<any>();

  constructor(@Inject(Injector) private injector: Injector, public ctrlService: ControlService) {
    super();
  }

  public ngOnInit(): void {
    this.controlForm = this.ctrlService.getControlType(this.injector);
    this.required = this.controlForm.hasValidator(Validators.required);
    this.setupLegendMessage();
  }

  writeValue(val: any): void {
    this.controlValue = val;
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onModelChange(event: any) {
    this.onChanged(event);
  }

  onChangeValue(event: any) {
    this.onTouched();
    this.changeEvent.emit(event);
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

}
